/** */
const labelsFilter = ["http://www.w3.org/2000/01/rdf-schema#label"];
const commentsFilter = ["http://www.w3.org/2000/01/rdf-schema#comment"];
//Поддерживаемые типы для перевода owl в VOWL
const types = ["http://www.w3.org/2002/07/owl#Class", "http://www.w3.org/2000/01/rdf-schema#Class",
  "http://www.w3.org/2002/07/owl#ObjectProperty", "http://www.w3.org/1999/02/22-rdf-syntax-ns#Property",
  "http://www.w3.org/2002/07/owl#DatatypeProperty", "http://www.w3.org/2002/07/owl#InverseFunctionalProperty",
  "http://www.w3.org/2002/07/owl#FunctionalProperty", "http://www.w3.org/2002/07/owl#TransitiveProperty",
  "http://www.w3.org/2002/07/owl#SymmetricProperty", "http://www.w3.org/2002/07/owl#AnnotationProperty"];

//Объекты, которые не нужно создавать 
const objectNoCreated = ["http://www.w3.org/2002/07/owl#Class", "http://www.w3.org/2000/01/rdf-schema#Class",
"http://www.w3.org/2002/07/owl#ObjectProperty", "http://www.w3.org/1999/02/22-rdf-syntax-ns#Property",
"http://www.w3.org/2002/07/owl#DatatypeProperty", "http://www.w3.org/2002/07/owl#InverseFunctionalProperty",
"http://www.w3.org/2002/07/owl#FunctionalProperty", "http://www.w3.org/2002/07/owl#AnnotationProperty",
"http://www.w3.org/2002/07/owl#TransitiveProperty", "http://www.w3.org/2002/07/owl#SymmetricProperty"];

//Типы узлов, которые относятся к классам
const classesType = ["owl:Thing", "owl:Class", "owl:equivalentClass", "rdfs:Literal", "owl:unionOf", 
  "owl:intersectionOf", "owl:complementOf"];
const _comment = "Создано приложением для семантической интеграции (версия 0.7.0), http://csi.semanticpro.org";
const settings = {"filter": {
  "checkBox": [
    {"id": "datatypeFilterCheckbox", "checked": false},
    {"id": "objectPropertyFilterCheckbox","checked": false},
    {"id": "subclassFilterCheckbox","checked": false},
    {"id": "disjointFilterCheckbox","checked": false},
    {"id": "setoperatorFilterCheckbox","checked": false}
  ],
  "degreeSliderValue": "0"
},
"modes": {
  "checkBox": [
    {"id": "pickandpinModuleCheckbox","checked": false},
    {"id": "nodescalingModuleCheckbox","checked": true},
    {"id": "compactnotationModuleCheckbox","checked": false},
    {"id": "colorexternalsModuleCheckbox","checked": true}
  ],
  "colorSwitchState": false
}}

const header2= { 
  "languages" : [ "ru", "undefined" ],
  "baseIris" : [ ],
  "prefixList" : {
    "owl" : "http://www.w3.org/2002/07/owl#",
    "rdf" : "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "terms" : "http://purl.org/dc/terms/",
    "skos" : "http://www.w3.org/2004/02/skos/core#",
    "xsd" : "http://www.w3.org/2001/XMLSchema#",
    "dc" : "http://purl.org/dc/elements/1.1/",
    "xml" : "http://www.w3.org/XML/1998/namespace",
    "dct" : "http://purl.org/dc/terms/",
    "rdfs" : "http://www.w3.org/2000/01/rdf-schema#",
  },
  "iri" : "",
  "labels" : { "undefined" : "" },
  title: ""
}

const maxThingCountLink = 120;

/** Помогает парсировать результаты SPARQL запроса */
module.exports = function (response) {
  var helper = {},
	    vars = (response && response.head)?response.head.vars:[],
      data = (response && response.results)?response.results.bindings:[],
      conversionSettings={},  //Настройки преобразования owl в vowl
      //Элементы заголовка, заполняемые в ходе парсинга
      //iri определяется по o.value д.б. http://www.w3.org/2002/07/owl#Ontology
      //соответственно заполняется title и description
      header={languages:["undefined"], baseIris:[], iri:"", title:{}}, //Ещё может быть version и author (author может быть массивом)
      namespaces= [],
      classes= [],
      classAttributes=[],
      properties=[],
      propertyAttributes= [],
      nodes=[],     //Служебный массив, из которого формируется classes и properties
      nodeAttributes=[],  //Служебный массив, из которого формируется classAttributes и propertyAttributes
      idNodes={},   // Идентификатор: IRI класса или свойства (по id (индекс массива nodes или nodesProperties) получить IRI
      nodeIds={},   // IRI: идентификатор (по IRI получить id (индекс массива nodes или nodesProperties))
      singleThing=null, //Идентификатор http://www.w3.org/2002/07/owl#Thing для элементов не имеющих привязки ни к одному из классов, например объявленные объектные свойства
      things=[],    // Служебный массив http://www.w3.org/2002/07/owl#Thing параметромами является id - узла, single является ли он single
      unknown={},   //Данные, которые не понятно к чему отнести, т.к. у них нет http://www.w3.org/1999/02/22-rdf-syntax-ns#type	или они относятся к не обрабатываемы элементам
      individuals={},   //Список элементов имеющих тип http://www.w3.org/2002/07/owl#NamedIndividual
      bnodes={},    //Анонимные узлы. Используются для расширенного представление свойств у классов и индивидуалов
      statistics={lang:[]}, //Статистика найденных элементов, для настройки header
      subjects = [], //Список все URI в субъектах
      externals=[]; //Дополнительные внешнии узлы


  helper.setResponse=function (response){
    vars = (response && response.head)?response.head.vars:[],
    data = (response && response.results)?response.results.bindings:[],
    conversionSettings = {},
    namespaces= [],
    classes= [],
    classAttributes=[],
    properties=[],
    propertyAttributes= [],
    nodes=[], 
    nodeAttributes=[],
    idNodes={}, 
    nodeIds={}, 
    singleThing=null,
    things=[],
    unknown={},
    individuals={},
    bnodes={},
    statistics={lang:[]},
    subjects=[];
  }

  helper.setConversionSettings=function(settings){
    conversionSettings = (settings)?JSON.parse(JSON.stringify(settings)):{};
    //Обрабатываем логирование, т.к. логирование может быть в extra_options
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.logger){
      conversionSettings.logger = conversionSettings.settings.extra_options.logger;
    }    
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.externals)
      externals = conversionSettings.settings.extra_options.externals;
  }

  function empty(){
    header={languages:["undefined"], baseIris:[], iri:"", title:{}}, namespaces=[], 
    classes= [], classAttributes=[], properties=[], propertyAttributes= [], 
    nodes=[], nodeAttributes=[], idNodes={}, nodeIds={}, singleThing=null, things=[], unknown={},
    individuals={}, bnodes={}, statistics={lang:[], totals:[]}, subjects=[];
  }

  /** Формирует список все классов в онтологии. 
   * По умолчнию  добавляется отдельные http://www.w3.org/2002/07/owl#Thing только если есть свойства, не меющие 
   * domain или range на объявленные классы
   * */
  helper.getClasses=function(){
    if ((classes.length<1) && (data.length>0)) 
      OWL2VOWL();
		return classes;
  };
  
  helper.getClassAttributes=function(){
    return classAttributes;
  }

  helper.getProperties=function(){
    if ((properties.length<1) && (data.length>0))
      OWL2VOWL();
		return properties;
  };

  helper.getPropertyAttributes=function(){
    return propertyAttributes;
  }

  helper.updateDecorator=function(node, element){
    // if (element.rdfType){
    //   const bg = nodesBgroundColor[element.rdfType];
    //   if (bg) node.backgroundColor(bg);
    // }
    //console.log("helper.updateDecorator", node, element, node.backgroundColor());
  }
  
  helper.getTitle = function(){
    return header.title;
  }

  helper.getHeader = function(){
    return header;
  }

  /** Визуальные настройки правой боковой панели см. sparqlSidebar.js. Если таких настроек 
   * нет, то  возвращается undefined */
  helper.getSlideBarSettings = function(){
    if ( conversionSettings && conversionSettings.settings && conversionSettings.settings.extra_options
      && conversionSettings.settings.extra_options.slideBar)
      return conversionSettings.settings.extra_options.slideBar;
    return undefined;
  }

  helper.getNamespaces=function(){
    return namespaces;
  }

  helper.getData = function (){
    return {_comment, header, namespace: [], settings, head: {vars}, results: {bindings:data}};
  }

  helper.getVOWL = function () {
    return {_comment, header, namespace: [], settings, class: this.getClasses(), classAttribute: this.getClassAttributes(),
    property: this.getProperties(), propertyAttribute: this.getPropertyAttributes()};
  }
  /** Функция формирует значение языка для аннотирующего или дата проперти. По умолчанию возвращает "undefined" */
  function makeLang(o){
    //Создадим статистику использования языков
    const lang = (o && o["xml:lang"])? o["xml:lang"]: "undefined";
    if (typeof statistics.lang[lang] === 'undefined') 
      statistics.lang[lang] = {name: lang, count: 0};
    statistics.lang[lang].count = statistics.lang[lang].count + 1;
    return lang;
  }
  /** Вычленить последнее значение в iri, для получения IRI-based */
  parseIRI_lastSection=function(iri){
    if (iri){
      if (iri.lastIndexOf('#')>0) return iri.substring(iri.lastIndexOf('#')+1);
      if (iri.lastIndexOf('/')>0) return iri.substring(iri.lastIndexOf('/')+1);
    }
    return iri;
  }
  /** Вычленить начальные значения в iri, для получения baseIri */
  parseIRI_firstSections=function(iri){
    if (iri){
      if (iri.lastIndexOf('#')>0) return iri.substring(0, iri.lastIndexOf('#'));
      if (iri.lastIndexOf('/')>0) return iri.substring(0, iri.lastIndexOf('/'));
    }
    return iri;
  }

  /** Формирует секцию baseIris в заголовке */
  makeBaseIris=function(iri){
    const baseIri = parseIRI_firstSections(iri);
    if (baseIri===iri) return baseIri;
    if (!header.baseIris.includes(baseIri))
    header.baseIris.push(baseIri);
    return baseIri;
  }

  /** Значение предиката соответствует парметру uri и type=uri */
  function isURI(predicat, uri, type="uri"){
    return (predicat && (predicat.type==type))? predicat.value == uri: false;
  }

  /** Значение предиката соответствует парметру uri */
  function isValue(predicat, value){
    return (predicat)? predicat.value == value: false;
  }

  /**
   * Функция конвертирующая содержимое онтологии (представлены в виде триплетов) в VOWL.
   * Функция заполняет секции classes, classAttributes, properties и propertyAttributes
   * Общая схема заполнения:
   * 1. Формируются classes и properties (используются триплеты, у которых предикат http://www.w3.org/1999/02/22-rdf-syntax-ns#type) 
   * с частичным заполнением classAttributes и propertyAttributes.
   * 2.
   */
  function OWL2VOWL(){
    empty();
    //console.log("owlHelper.js OWL2VOWL()", conversionSettings);
    //Список уже установленных связей http://www.w3.org/2002/07/owl#disjointWith. Т.к. они дублируются в SPARQL.
    const hasDisjointWith = []; 
    //Определим все субъекты
    subjects = data.filter(
        item => item.s.type == "uri"
      ).map(
        item => item.s.value
      ).filter((value, index, self) =>
        index === self.findIndex((t) => (
          t === value
        ))
      );
    //Определим все классы, как элементы имеющие предикат http://www.w3.org/1999/02/22-rdf-syntax-ns#type
    const items = data.filter(
      item => (
        isURI(item.p, "http://www.w3.org/1999/02/22-rdf-syntax-ns#type") && item.o && (item.o.type=="uri")
      )
    );
    //Определим все субъекты, которые определяются как Individual
    //Для них создавать отдельный класс ненадо. Эти элементы включаются в узел в свойство individuals
    const individualsSubject = data.filter(
      item => (
        isURI(item.p, "http://www.w3.org/1999/02/22-rdf-syntax-ns#type") && item.o && (item.o.type=="uri") && item.o.value=="http://www.w3.org/2002/07/owl#NamedIndividual"
      )
    );
    const individualsType = [];
    //Формирование списка индивидуалов 
    for (let i = 0; i < individualsSubject.length; i++) 
      individualsType.push(individualsSubject[i].s.value);
    //Формирование узлов. Индивидуалы не включаем
    for (let i = 0; i < items.length; i++){
      if (!individualsType.includes(items[i].s.value))
        vowlParseType(items[i].s, items[i].p, items[i].o);
    }
    //Добавим специальные внешние узлы (см. "external":[{"iri": "http://www.w3.org/2004/02/skos/core#Concept", "type": "ExternalClass"}] )
    for (let i = 0; i < externals.length; i++) {
      const item = externals[i];
      const idSubject = nodes.length;
      idNodes[idSubject]=item.iri; 
      nodeIds[item.iri]=idSubject;
      nodes.push({"id": idSubject, "type": item.type})
      nodeAttributes.push({iri: item.iri, id: idSubject, attrs:[], "label": {"undefined": "????"}, "rdfType":item.iri});
    }
    //Формирование Индивидуалов (затем включим в созданный по типу класс)
    for (let i = 0; i < items.length; i++){
      if (individualsType.includes(items[i].s.value)){
        if (typeof nodeIds[items[i].o.value] === 'undefined') continue;
        const idSubject = nodeIds[items[i].o.value];
        // if (!Array.isArray(nodeAttributes[idSubject].individuals)) nodeAttributes[idSubject].individuals = [];
        // nodeAttributes[idSubject].individuals.push({iri:items[i].s.value});
        if (typeof individuals[items[i].s.value] === 'undefined') 
          individuals[items[i].s.value] = {attrs:[], iri: items[i].s.value, type: items[i].s.type, nodes:[], baseIri : makeBaseIris(items[i].s.value)};
        individuals[items[i].s.value].nodes.push({type: items[i].o.value, id:idSubject});
      }        
    }

    //Заполним класс их свойствами. 
    //Сформируем массив для классов (nodeAttributes) индивидуалов (individuals) и анонимных узлов (bnodes)
    //Остальное, что не понятно куда отнести в  unknown
    for (let i = 0; i < data.length; i++) {
      const item = data[i];          
      let index = (item.s && ((item.s.type=="uri")||(item.s.type=="bnode")))? nodeIds[item.s.value]: null;
      if ((index != null) && (typeof index !== 'undefined')) {
        //console.log(index, nodeAttributes[index], i, item);
        if (!nodeAttributes[index].attrs)
          nodeAttributes[index].attrs = [];
        nodeAttributes[index].attrs.push({p: item.p, o: item.o});
      } else {
        //Возможно, что это характеристика индивидуала
        const individual = individuals[item.s.value];
        if (individual){
          individual.attrs.push({p: item.p, o: item.o});
          continue;
        }
        //Возможно, что это элемент анонимного узла
        if (item.s && (item.s.type=="bnode")){
          if (typeof bnodes[item.s.value] === 'undefined') 
            bnodes[item.s.value]={attrs:[], iri: item.s.value, type: "anonymous"};
          bnodes[item.s.value].attrs.push({p: item.p, o: item.o});
          continue;
        }
        //Возможно, что это характеристика онтологии, которая фиксируется в заголовке
        if (vowlHeaderFromOntology(item.s, item.p, item.o)) continue;
        //Возможно это внешний элемент, который не описан в онтологии и для него потом создадим узел
        if (item.s && ((item.s.type=="uri")||(item.s.type=="bnode"))){
          if (typeof unknown[item.s.value] === 'undefined') unknown[item.s.value]={attrs:[], iri: item.s.value};
          unknown[item.s.value].attrs.push({p: item.p, o: item.o});
        }
      }
      //Обработка для subClassOf. 
      if (isURI(item.p, "http://www.w3.org/2000/01/rdf-schema#subClassOf"))
        vowlSubClassOf(item.s, item.p, item.o);
      if (isURI(item.p, "http://www.w3.org/2002/07/owl#equivalentClass"))
        vowlEquivalentClass(item.s, item.p, item.o);
      if (isURI(item.p, "http://www.w3.org/2002/07/owl#disjointWith"))
        vowlDisjointWith(item.s, item.p, item.o);
    };

    //Обработка атрибутов у узлов
    parseAttributes(nodeAttributes);
    //Обработаем атрибуты индивидуалов
    parseAttributes(individuals);
    //Обработаем атрибуты анонимных узлов
    parseAttributes(bnodes);

    //console.log("OWL2VOWLattrs", nodeAttributes, individuals, bnodes);

    //Смапировать анонимные узлы с классами и индивидуалами
    bnodesMapToNodes(individuals);
    bnodesMapToNodes(nodeAttributes);
    //Смапировать индивидуалы на классы
    individualsMapToNodes();

    //Финальная пост обработка
    vowlAfterOWL2VOWL();
    //console.log("function OWL2VOWL()", items, nodes, nodeAttributes);
    //Перенесём элементы в classes и classAttributes
    for (let i = 0; i < nodes.length; i++) {
      if (classesType.includes(nodes[i].type)){
        classes.push(nodes[i]);
        classAttributes.push(nodeAttributes[i]);
      } else {
        properties.push(nodes[i]);
        propertyAttributes.push(nodeAttributes[i]);
      }
    }
    //console.log("owlHelper.js function OWL2VOWL()", JSON.stringify(propertyAttributes));
    //console.log("function OWL2VOWL() final 1 ", classes, classAttributes);
    //console.log("function OWL2VOWL() final 2 ", properties, propertyAttributes); //, JSON.stringify(propertyAttributes));
    //console.log("function OWL2VOWL() final 3 ", nodeIds, idNodes);
  }


  /** Связать индивидуалы с их классами. В атрибутах узлов заполняется свойство individuals */
  function individualsMapToNodes(){
    const keys = Object.keys(individuals);
    for (let i = 0; i < keys.length; i++) {
      const individual = individuals[keys[i]]; 
      //console.log("owlHelper.js function individualsMapToNodes()", keys, individual);
      //Конструкция ниже вызывает ошибку 
      //TypeError: Cannot assign to read only property 'exports' of object '#<Object>'
      //В местах импорта модуля
      //const nodes = [...individual.nodes]; 
      const nodes = individual.nodes;
      for (let j = 0; j < nodes.length; j++) {
        const node = nodes[j];
        if (!Array.isArray(nodeAttributes[node.id].individuals)) nodeAttributes[node.id].individuals = [];
        if (individual.hasOwnProperty("nodes")) delete individual.nodes;
        if (individual.hasOwnProperty("attrs")) delete individual.attrs;
        if (individual.hasOwnProperty("type")) delete individual.type;
        //В VOWL индивидуалы вместо label имеют свойство labels
        if (!individual.hasOwnProperty("labels")){
          if (individual.hasOwnProperty("label"))
            individual["labels"] = individual.label;
        }
        nodeAttributes[node.id].individuals.push(individual);
      }
    }
   }

  /** Связать анонимные узлы с классами и индивидуалы. */
  function bnodesMapToNodes(items){
    const keys = Object.keys(items);
    for (let i = 0; i < keys.length; i++) {
      const item = items[keys[i]]; 
      if (item.annotations && (Object.keys(item.annotations).length>0)){
        bnodesMapToAnnotations(item.annotations);
      }
    }
  }

  function bnodesMapToAnnotations(annotations){
    const keys = Object.keys(annotations);
    for (let i = 0; i < keys.length; i++) {
      const items = annotations[keys[i]]
      for (let j = 0; j < items.length; j++) {
        bnodesMapToAnnotation(items[j])
      }
    }
  }

  function bnodesMapToAnnotation(annotation){
    //Это анонимный узел
    if (annotation.type !="bnode") return;
    annotation.type="anonymous";
    //Заполним значениями из анонимного узла
    if (typeof bnodes[annotation.value] === 'undefined') return;
    const bnode = bnodes[annotation.value];
    if (!annotation.hasOwnProperty("label")){
      if (bnode.hasOwnProperty("label"))
        annotation["label"] = bnode.label;
    }
    annotation["annotations"]={labels:[], comments:[], description:[], deprecated: false, identifierToAnnotation:[]};
    if (bnode.hasOwnProperty("comments")) annotation.annotations.comments = bnode.comments;
    if (bnode.hasOwnProperty("description")) annotation.annotations.description = bnode.description;
    if (bnode.hasOwnProperty("annotations"))
      annotation.annotations.identifierToAnnotation=bnode.annotations;
    //Добавим labels
    if (bnode.hasOwnProperty("label")){
      //Преобразуем в массив {"identifier": "label", "language": "undefined", "value": "Дата отчёта","type": "label"}
      Object.keys(bnode.label).forEach(lang => {
        if (lang != "IRI-based")
          annotation.annotations.labels.push({"identifier": "label", "language": lang, "value": bnode.label[lang],"type": "label"})
      })
    }
  }

  /** Обработка attrs в списках для формирования аннотирующих свойств */
  function parseAttributes(items){
    //Так как может быть массивом, и объектом
    const keys = Object.keys(items);
    for (let i = 0; i < keys.length; i++) {
      const item = items[keys[i]]; 
      item.label = {"IRI-based": parseIRI_lastSection(item.iri)};
      //Индекс элемента в nodeAttributes
      const index = nodeIds[item.iri]? nodeIds[item.iri]: i
      //Для Thing и Literal никаких специальных обработок не нужно
      if ((item.iri == "http://www.w3.org/2002/07/owl#Thing") || (item.iri == "http://www.w3.org/2000/01/rdf-schema#Literal"))
        continue;
      //Отсутствие атрибутов, означает, что ресурс внешний (либо баг в онтологии, т.е. класс не доописан)
      if (!Array.isArray(item.attrs) || (item.attrs.length==0)){
        //console.log("if (!Array.isArray(item.attrs) || (item.attrs.length==0))", item);
        if (!subjects.includes(item.iri))
          vowlIncludeInAttributes(index, "external");
        continue;
      }
      //Проверим, что iri соответствует header.iri (т.е. класс относиться к онтологии) иначе он внешний
      if (header.iri && item.iri && (item.iri.indexOf(header.iri)!=0) && !subjects.includes(item.iri))
        vowlIncludeInAttributes(index, "external");
      //Заполним метками
      vowlLabel(item);
      //Заполним комментарии
      vowlComment(item);
      //Заполним аннотирующие свойства
      const annotations = item.attrs.filter(attr=> ( attr.p && (attr.p.type=="uri") && (!labelsFilter.includes(attr.p.value))));
      if (annotations.length>0) item.annotations = {};
      for (let j = 0; j < annotations.length; j++) {
        const a = annotations[j];
        const id = parseIRI_lastSection(a.p.value);
        if (!Array.isArray(item.annotations[id]))
          item.annotations[id] = [];
        const values = {"identifier": id, type: a.o.type, value: a.o.value, language: "undefined"};
        if (a.o["xml:lang"]) values.language = a.o["xml:lang"];
        if (values.type=="uri") values.type="iri";
        item.annotations[id][item.annotations[id].length] = values;
      }
      //Заполним range и domain ObjectProperty
      vowlObjectPropertyRangeDomain(item);
      //Заполним superproperty и subproperty
      vowlObjectPropertySubPropertyOf(item);
      //Заполним inverse
      vowlObjectPropertyInverseOf(item);
      //inverse functional
      vowlObjectPropertyInverseFunctionalProperty(item);
      //functional
      vowlObjectPropertyFunctionalProperty(item);
      //transitive
      vowlObjectPropertyTransitiveProperty(item)
      //symmetric
      vowlObjectPropertySymmetricProperty(item)
      //Заполним range и domain для DatatypeProperty
      vowlDatatypePropertyRangeDomain(item);
      //Обработка setOperation
      vowlSetOperators(item);
      //Очистим attrs
      item.attrs = [];
    }
  }

  /** Заполнение информации в заголовок из триплетов, у которых s является IRI онтологии.
   * Возвращает true, если это относиться к описанию онтологии  */
  function vowlHeaderFromOntology(s, p, o){
    //console.log("owlHelper.cjs", "vowlHeaderFromOntology", s, p, o);    
    if ((s.type=="uri") && (s.value == header.iri ) && header.iri){
      //console.log("function vowlHeaderFromOntology(s, p, o)", s, p, o);
      if (isURI(p, "http://purl.org/dc/elements/1.1/title") || isURI(p, "http://purl.org/dc/terms/title")){
        header.title[makeLang(o)] = o.value
      }
      if (isURI(p, "http://purl.org/dc/elements/1.1/description") || isURI(p, "http://purl.org/dc/terms/description")){
        if (typeof header["description"] === 'undefined') header["description"] = {};
        header.description[makeLang(o)] = o.value
      }
      if (isURI(p, "http://www.w3.org/2002/07/owl#versionInfo")){
        if (typeof header["version"] === 'undefined') header["version"] = {};
        header.version = o.value
      }
      if (isURI(p, "http://purl.org/dc/terms/creator")){
        if (typeof header["author"] === 'undefined') header["author"] = [];
        if (o.type === 'literal')
          header.author.push(o.value);
      }

      return true;
    }
    return false;
  }
  /** Добавляет в classAttribute в attributes значение value. id - индекс элемента в attributes  */
  function vowlIncludeInAttributes(id, value){
    
    if (!Array.isArray(nodeAttributes[id].attributes)) nodeAttributes[id]["attributes"] = [];
    if (!nodeAttributes[id].attributes.includes(value)) 
      nodeAttributes[id].attributes.push(value)
  }

  /** Создаёт новую запись в nodes и заполняет массивы базовыми секциям для http://www.w3.org/2002/07/owl#Thing */
  function vowlFillThing (linkClone = false, single=false){
    const id = nodes.length;
    idNodes[id]="http://www.w3.org/2002/07/owl#Thing";
    if (typeof nodeIds["http://www.w3.org/2002/07/owl#Thing"] === 'undefined')
      nodeIds["http://www.w3.org/2002/07/owl#Thing"]=id;  
    nodes.push({id, "type": "owl:Thing"})
    nodeAttributes.push({iri: "http://www.w3.org/2002/07/owl#Thing", id, attrs:[], "label": {"undefined": "Thing"}, "rdfType":"http://www.w3.org/2002/07/owl#Thing", count: 0});
    if (linkClone && singleThing){
      const index = nodes.length;
      nodes.push({"id": index, "type": "CloneNode"});
      nodeAttributes.push({range: id.toString(), id: index, domain: singleThing.toString(), "attributes" : [ "anonymous" ]});  
    }
    things[things.length] = {id, single};
    
    return id;
  }

  /** Создаёт узел для неизвестного элемента. Возвращает индекс узла в nodes */
  function vowlIncludeUnknown(uri){
    if (typeof unknown[uri] === 'undefined') return null;
    
    if (uri === "http://www.w3.org/2002/07/owl#Thing") {
      if (!singleThing){
        singleThing = vowlFillThing (true, true);
        //добавление в описание свойсва парметра charac. Если указывать через атрибут, то 
        //Узел будет покрашен синим цветомв
        nodes[singleThing].annotations = {charac: [
          {identifier: 'charac.', type: 'literal', value: "external", language: 'undefined'}
        ]};
      }
      return nodeIds[uri];
    }
    //console.log("owlHelper.js function vowlIncludeUnknown(uri)", uri, unknown[uri], nodeIds[uri]);
    //Т.е. описание объектов, включаемых в онтологию не создавать
    vowlParseType({type:"uri", value: uri}, {}, {type:"uri", value:"http://www.w3.org/2002/07/owl#Class"});
    const index = nodeIds[uri];
    if ((index == undefined) || (typeof index === 'undefined')){
      console.warn("Unknown uri ",uri, ". Add uri in settings.createNodes");
      return null;
    }
    nodeAttributes[index].attrs = unknown[uri].attrs;
    //Заполним метками
    vowlLabel(nodeAttributes[index]);
    //Заполним комментарии
    vowlComment(nodeAttributes[index]);
    vowlIncludeInAttributes(index, "external");
    return index;
  }

  /** Создаёт новую запись в nodes и заполняет массивы базовыми секциям для литеральных значений */
  function vowlFillAnnotation (){
    const id = nodes.length;
    idNodes[id]="owl:AnnotationProperty";
    nodes.push({id, "type": "owl:AnnotationProperty"})
    nodeAttributes.push({iri: "http://www.w3.org/2000/01/rdf-schema#Literal", id, attrs:[], "label": {"IRI-based": "Literal", "undefined": "Literal"}});
    return id;
  }

  /** Создаёт новую запись в nodes и заполняет массивы базовыми секциям для литеральных значений */
  function vowlFillLiteral (){
    const id = nodes.length;
    idNodes[id]="rdfs:Literal";
    nodes.push({id, "type": "rdfs:Literal"})
    nodeAttributes.push({iri: "http://www.w3.org/2000/01/rdf-schema#Literal", id, attrs:[], "label": {"IRI-based": "Literal", "undefined": "Literal"}});
    return id;
  }

  /** Создаёт новую запись в nodes и заполняет массивы базовыми секциям для setOperatorProperty */
  function vowlFillSetOperatorProperty (domain, range, uriNode){
    const id = nodes.length;
    idNodes[id]="setOperatorProperty";
    nodeIds[uriNode] = id;
    nodes.push({id, "type": "setOperatorProperty"})
    nodeAttributes.push({iri: uriNode, id, domain: domain.toString(), range: range.toString()});
    return id;
  }

  /** Обрабатывает триплет, в котором p.value == http://www.w3.org/1999/02/22-rdf-syntax-ns#type 
   * 1. s - описывает класс или свойство. (по умолчанию ставить owl:Class, кроме собого случая owl:Thing)
   *  или свойство  owl:objectProperty. В дальнейшем эти типа могут менять в зависимости от 
   * 2. o - является типом owl:Class (и заполняется subClasses и superClasses )
  */
  function vowlParseType (s, p, o){
    //Проверим особый случай http://www.w3.org/2002/07/owl#Ontology. Значит описание онтологии
    if (o.value == "http://www.w3.org/2002/07/owl#Ontology"){
        header.iri = s.value;
        return;
    }
    //Определим, что можем обработать соответствующий тип. Иначе дадим лог с предупреждением
    if (!checkIsNodeCreate(s, o)) return;
    //Определим, можем ли создать тип для объекта
    if (!checkIsTypeCreate(s, o)) return;
    //Заведём id subject
    const idSubject = (typeof nodeIds[s.value] === 'undefined')? nodes.length: nodeIds[s.value];
    let type = "owl:Class";
    if (isURI(o, "http://www.w3.org/2002/07/owl#Thing")) type = "owl:Thing";
    if (isURI(o, "http://www.w3.org/2002/07/owl#ObjectProperty")) type = "owl:objectProperty";
    if (isURI(o, "http://www.w3.org/2002/07/owl#DatatypeProperty")) type = "owl:datatypeProperty";
    if (isURI(o, "http://www.w3.org/2002/07/owl#AnnotationProperty")) type = "owl:annotationProperty";
    if (isURI(o, "http://www.w3.org/2002/07/owl#FunctionalProperty")) type = "owl:objectProperty";
    if (isURI(o, "http://www.w3.org/2002/07/owl#InverseFunctionalProperty")) type = "owl:objectProperty";
    if (idSubject == nodes.length){
      idNodes[idSubject]=s.value; 
      nodeIds[s.value]=idSubject;  
      nodes.push({"id": idSubject, type})
      nodeAttributes.push({iri: s.value, id: idSubject, attrs:[], "label": {"undefined": "????"}});
    } else {
      const wasType = nodes[idSubject].type;
      //Может быть как для ObjectProperty так и для DatatypeProperty. Если задан "owl:Class", то зададим "owl:objectProperty"
      //Дальнейший анализ типов изменить на правильный 
      if (isURI(o, "http://www.w3.org/2002/07/owl#FunctionalProperty") && (wasType=="owl:Class")) 
        type = "owl:objectProperty";
      if (isURI(o, "http://www.w3.org/2002/07/owl#InverseFunctionalProperty") && (wasType=="owl:Class")) 
        type = "owl:objectProperty";
      //Изменим тип, так как может быть много типов
      if ((type == "owl:datatypeProperty")||(type == "owl:annotationProperty")) 
        nodes[idSubject].type = type;
      if (wasType == "owl:Class") 
        nodes[idSubject].type = type;
    }
    if (!checkIsTypeCreate(o, s)) return;
    const idObject = (typeof nodeIds[o.value] === 'undefined')? nodes.length: nodeIds[o.value];  
    //console.log("function vowlParseType (s, p, o)", idSubject, idObject, nodeIds[s.value], nodeIds[o.value]);
    if (idObject == nodes.length){
      idNodes[idObject]=o.value; 
      nodeIds[o.value]=idObject;  
      nodes.push({"id": idObject, "type": "owl:Class"})
      nodeAttributes.push({iri: o.value, id: idObject, attrs:[], "label": {"undefined": "????"}});
    }
    if (checkTypeAsSuperClass(s, o)){
      const index = nodes.length;
      nodes.push({"id": index, "type": "rdfs:SubClassOf"});
      nodeAttributes.push({range: idObject.toString(), id: index, domain: idSubject.toString(), "attributes" : [ "object", "anonymous" ]});  
    }
  }

  /** Обрабатывается триплет с предикатом http://www.w3.org/2000/01/rdf-schema#subClassOf
   * Формируется массив ссылок superClasses в s. И обратная ссылка subClasses в o
   */
  function vowlSubClassOf (s, p, o) {
    const idSubject = nodeIds[s.value]; if (typeof idSubject === 'undefined') return;
    const idObject = nodeIds[o.value]; if (typeof idObject === 'undefined') return;
    //Определим superClasses
    if (!Array.isArray(nodeAttributes[idSubject].superClasses)) nodeAttributes[idSubject]["superClasses"] = [];
    if (!nodeAttributes[idSubject].superClasses.includes(idObject.toString())) 
      nodeAttributes[idSubject].superClasses.push(idObject.toString())
    //Определим subClasses
    if (!Array.isArray(nodeAttributes[idObject].subClasses)) nodeAttributes[idObject]["subClasses"] = [];
    if (!nodeAttributes[idObject].subClasses.includes(idSubject.toString())) 
      nodeAttributes[idObject].subClasses.push(idSubject.toString())

    const index = nodes.length;
    nodes.push({"id": index, "type": "rdfs:SubClassOf"});
    nodeAttributes.push({range: idObject.toString(), id: index, domain: idSubject.toString(), "attributes" : [ "object", "anonymous" ]});
    //console.log("function vowlSubClassOf (s, p, o)", index, nodes, node);
  }

  /** Обрабатываеться триплет с предикатом http://www.w3.org/2002/07/owl#equivalentClass
   * Формируется массив ссылок equivalent в s и значение equivalent в attributes.
   * В триплетах возможно задание эквивалентности 
   * 1. http://schema.org/CreativeWork http://www.w3.org/2002/07/owl#equivalentClass http://xmlns.com/foaf/0.1/Document
   * так и 
   * 2. http://xmlns.com/foaf/0.1/Document http://www.w3.org/2002/07/owl#equivalentClass http://schema.org/CreativeWork
   */
  function vowlEquivalentClass (s, p, o) {
    debugger
    //console.log("owlHelper.js function vowlEquivalentClass (s, p, o) ", s, o, nodeIds[s.value], nodeIds[o.value]);
    const idSubject = nodeIds[s.value]; 
    if (typeof idSubject === 'undefined') return;
    let idObject = nodeIds[o.value];
    //Для внешнего ресурса вызова vowlParseType может не быть, так как он неопределён в онтологии
    if (typeof idObject === 'undefined'){
      //Создадим пустой элемент
      idObject = nodes.length
      idNodes[idObject]=o.value; 
      nodeIds[o.value]=idObject;  
      nodes.push({"id": idObject, "type": "owl:equivalentClass"})
      nodeAttributes.push({iri: o.value, id: idObject, attributes: ["external"], "label": {"IRI-based": parseIRI_lastSection(o.value)}});
    }
    //Определим equivalent
    nodes[idSubject].type = "owl:equivalentClass";
    if (!Array.isArray(nodeAttributes[idSubject].equivalent)) nodeAttributes[idSubject]["equivalent"] = [];
    if (!nodeAttributes[idSubject].equivalent.includes(idObject.toString())) 
      nodeAttributes[idSubject].equivalent.push(idObject.toString())
    vowlIncludeInAttributes(idSubject, "equivalent");
    vowlIncludeInAttributes(idObject, "equivalent");
  }

  /** Обрабатываеться триплет с предикатом http://www.w3.org/2002/07/owl#disjointWith
   * Формируется новая записб в совойствах типа owl:disjointWith
   */
  function vowlDisjointWith (s, p, o) {
    const domain = nodeIds[s.value];
    const range = nodeIds[o.value];
    if ((domain==null) ||(typeof domain === 'undefined') || (range==null) || (typeof range === 'undefined')){
        console.warn("Link parse for disjointWith. No range or domain", s,p,o); return;
    }
    //Связи уже могут быть
    if (typeof nodeIds[range.toString()+"-"+domain.toString()] !== 'undefined') return;
    if (typeof nodeIds[domain.toString()+"-"+range.toString()] !== 'undefined') return;
    const id = nodes.length;
    nodes.push({"id": id, "type": "owl:disjointWith"});
    nodeAttributes.push({range: range.toString(), id, domain: domain.toString(), "attributes" : [ "object", "anonymous" ]});
    nodeIds[range.toString()+"-"+domain.toString()] = id;
    nodeIds[domain.toString()+"-"+range.toString()] = id;
    idNodes[id]=range.toString()+"-"+domain.toString();
    idNodes[id]=domain.toString()+"-"+range.toString();
  }

  /** Заполнение значениями секции label */
  function vowlLabel(item){
    const labels = item.attrs.filter(attr=> ( attr.p && (attr.p.type=="uri") && (labelsFilter.includes(attr.p.value))))
      .map(attr => {return {lang: makeLang(attr.o), value: attr.o.value}});
    if (labels.length>0) {
      labels.map(label => item.label[label.lang] = label.value);
      if (labels.filter(label => label.lang=="undefined").length<1);
        item.label["undefined"] = labels[0].value;
    };
  }

  /** Заполнение значениями секции label */
  function vowlComment(item){
    const texts = item.attrs.filter(attr=> ( attr.p && (attr.p.type=="uri") && (commentsFilter.includes(attr.p.value))))
      .map(attr => {return {lang: makeLang(attr.o), value: attr.o.value}});
    if (texts.length>0) {
      item.comment={};
      texts.map(text => item.comment[text.lang] = text.value);
      if (texts.filter(text => text.lang=="undefined").length<1);
        item.comment["undefined"] = texts[0].value;
      //Удалим attrs, что бы не попали в annotations
      item.attrs = item.attrs.filter(attr=> !( attr.p && (attr.p.type=="uri") && (commentsFilter.includes(attr.p.value))))
    };
  }

  /** Получение описание атрибута (значение предиката и объекта из триплета)*/
  function firstAttributes(attrs, uri){
    const items = attrs.filter(a => isValue(a.p, uri));
    return (items.length>0)?items[0].o: null;
  }

  /** Связывает item с одиночным Thing (item может быть как DataProperty, DataProperty) 
   * Возвращает true, если такая связь установлена. В item заполняются значения item.domain и item.range;
  */
  function linkWithThing(item, domainObject, rangeObject){
    if ((domainObject == "http://www.w3.org/2002/07/owl#Thing")&&(rangeObject=="http://www.w3.org/2002/07/owl#Thing")){
      if (!singleThing)
        singleThing = vowlFillThing (true, true);
      else {
        if (nodeAttributes[singleThing].count>maxThingCountLink)
          singleThing = vowlFillThing (true, true);
      }
      nodeAttributes[singleThing].count = nodeAttributes[singleThing].count+2;
      item.domain = singleThing.toString();
      item.range = singleThing.toString();
      return true;
    }
    return false;
  }
  /** Обрабатывается уже сформированный элемент типа "owl:objectProperty".
   * Назначить rande и domain. Для "http://www.w3.org/2002/07/owl#Thing"
   * создаётся элемент, специально связанный с domain или range
   */
  function vowlObjectPropertyRangeDomain (item){
    const id = item.id;
    //Для индивидуалов и пустых узлов id может на быть
    if (typeof id === 'undefined') return;
    if (nodes[id].type != "owl:objectProperty") return;
    const oDomain = firstAttributes(item.attrs, "http://www.w3.org/2000/01/rdf-schema#domain");
    const oRange = firstAttributes(item.attrs, "http://www.w3.org/2000/01/rdf-schema#range");
    //item.attrs.filter(a => isValue(a.p, "http://www.w3.org/2000/01/rdf-schema#domain"))
    let domain = null, range = null;
    //Если не задан domain или range, до связываем с Thing
    const domainObject = (oDomain) ? oDomain.value : "http://www.w3.org/2002/07/owl#Thing";
    const rangeObject = (oRange) ? oRange.value : "http://www.w3.org/2002/07/owl#Thing";
    //Возможно домен относиться к узлу из unknown
    if ((typeof nodeIds[domainObject] === 'undefined') && domainObject) domain = vowlIncludeUnknown(domainObject);
    //Возможно range относиться к узлу из unknown
    if ((typeof nodeIds[rangeObject] === 'undefined') && rangeObject) range = vowlIncludeUnknown(rangeObject);
    
    if (domainObject && rangeObject){
      //Возможно, что domainObject и rangeObject является Think, т.е. не привязан ни к одному из классов
      if (linkWithThing(item, domainObject, rangeObject )) return;
      //Отбирается класс, которые в domain или range и для него создаётся Thing
      if ((domainObject == "http://www.w3.org/2002/07/owl#Thing") || (rangeObject=="http://www.w3.org/2002/07/owl#Thing")){
        const c = (domainObject == "http://www.w3.org/2002/07/owl#Thing")? nodeIds[rangeObject]:nodeIds[domainObject];
        //console.log("function vowlObjectProperty (item)", item, domainObject, rangeObject, c);
        if (c){
          //Свяжем с одним объектом Thing
          if (!singleThing) 
            singleThing = vowlFillThing (true, true);
          else {
            if (nodeAttributes[singleThing].count>maxThingCountLink)
              singleThing = vowlFillThing (true, true);
          }
          nodeAttributes[singleThing].count = nodeAttributes[singleThing].count+1;
          if (!nodeAttributes[c].thing) nodeAttributes[c].thing = singleThing;
          //if (!nodeAttributes[c].thing) nodeAttributes[c].thing = vowlFillThing (false, false);
          domain = (domainObject == "http://www.w3.org/2002/07/owl#Thing")? nodeAttributes[c].thing:nodeIds[domainObject];
          range = (rangeObject =="http://www.w3.org/2002/07/owl#Thing")? nodeAttributes[c].thing: nodeIds[rangeObject];  
        } 
      } else {
        domain = nodeIds[domainObject];
        range = nodeIds[rangeObject];
      }
    }
    if ((domain==null) || (range == null) || (typeof domain === 'undefined')||(typeof range === 'undefined')){
      console.warn("Link parse. No range or domain in ObjectProperty", item, domainObject, domain, rangeObject, range);
    } else {
      item.domain = domain.toString();
      item.range = range.toString();
    }
    vowlIncludeInAttributes(id, "object");
  }

  /** Обрабатывается уже сформированный элемент типа "owl:objectProperty".
   * Назначить superproperty если есть свойство  http://www.w3.org/2000/01/rdf-schema#subPropertyOf
   * а для связанного (o) назначить subproperty.
   */
  function vowlObjectPropertySubPropertyOf (item){
    const id = item.id;
    const spoItems = item.attrs.filter(a => isURI(a.p, "http://www.w3.org/2000/01/rdf-schema#subPropertyOf"));
    for (let index = 0; index < spoItems.length; index++) {
      const spo = spoItems[index];
      const idObject = nodeIds[spo.o.value];
      //console.log("function vowlObjectPropertySubPropertyOf (item)", item, spoItems, spo, idObject);
      if (typeof idObject === 'undefined'){
        console.warn("Not found subPropertyOf element", item);
        continue;
      }
      if (!Array.isArray(item.superproperty)) item["superproperty"] = [];
      if (!item.superproperty.includes(idObject.toString())) 
        item.superproperty.push(idObject.toString())
      if (!Array.isArray(nodeAttributes[idObject].subproperty)) nodeAttributes[idObject]["subproperty"] = [];
      if (typeof id === 'undefined'){
        //console.warn("In owlHelper.js vowlObjectPropertySubPropertyOf (item) item not id", item);
        continue;
      }
      if (!nodeAttributes[idObject].subproperty.includes(id.toString())) 
      nodeAttributes[idObject].subproperty.push(id.toString())    
      //console.log("function vowlObjectPropertySubPropertyOf (item) result", item, nodeAttributes[idObject]);
    }
  }

  /** Обрабаывается уже сформированный элемент типа "owl:objectProperty".
   * Назначить inverse если есть свойство  http://www.w3.org/2002/07/owl#inverseOf
   */
  function vowlObjectPropertyInverseOf (item){
    const id = item.id;
    const ioItems = item.attrs.filter(a => isURI(a.p, "http://www.w3.org/2002/07/owl#inverseOf"));
    for (let index = 0; index < ioItems.length; index++) {
      const io = ioItems[index];
      const idObject = nodeIds[io.o.value];
      //console.log("function vowlObjectPropertySubPropertyOf (item)", item, spoItems, spo, idObject);
      if (typeof idObject === 'undefined'){
        console.warn("Not found inverseOf element", item);
        continue;
      }
      item["inverse"] = idObject.toString();
    }
  }

  /** Обрабатывается уже сформированный элемент типа "owl:objectProperty".
   * Назначить inverse functional если есть свойство  http://www.w3.org/2002/07/owl#InverseFunctionalProperty
   */
  function vowlObjectPropertyInverseFunctionalProperty (item){
    const id = item.id;
    const ifpItems = item.attrs.filter(a => isURI(a.o, "http://www.w3.org/2002/07/owl#InverseFunctionalProperty"));
    if (ifpItems.length>0)
      vowlIncludeInAttributes(id, "inverse functional");
  }

  /** Обрабатывается уже сформированный элемент типа "owl:objectProperty".
   * Назначить functional если есть свойство  http://www.w3.org/2002/07/owl#FunctionalProperty
   */
  function vowlObjectPropertyFunctionalProperty (item){
    const id = item.id;
    const ifpItems = item.attrs.filter(a => isURI(a.o, "http://www.w3.org/2002/07/owl#FunctionalProperty"));
    if (ifpItems.length>0)
      vowlIncludeInAttributes(id, "functional");
  }

  /** Обрабатывается уже сформированный элемент типа "owl:objectProperty".
   * Назначить functional если есть свойство  http://www.w3.org/2002/07/owl#TransitiveProperty */
  function vowlObjectPropertyTransitiveProperty (item){
    const id = item.id;
    const tpItems = item.attrs.filter(a => isURI(a.o, "http://www.w3.org/2002/07/owl#TransitiveProperty"));
    if (tpItems.length>0)
      vowlIncludeInAttributes(id, "transitive");
  }

  /** Обрабатывается уже сформированный элемент типа "owl:objectProperty".
   * Назначить functional если есть свойство  http://www.w3.org/2002/07/owl#SymmetricProperty */
   function vowlObjectPropertySymmetricProperty (item){
    const id = item.id;
    const spItems = item.attrs.filter(a => isURI(a.o, "http://www.w3.org/2002/07/owl#SymmetricProperty"));
    if (spItems.length>0)
      vowlIncludeInAttributes(id, "symmetric");
  }

  /** Обрабатывается уже сформированный элемент типа "owl:datatypeProperty".
   * Назначить rande и domain. Создаётся узел rdfs:Literal для "range" и если domain не указан - "http://www.w3.org/2002/07/owl#Thing"
   */
  function vowlDatatypePropertyRangeDomain (item){
     const id = item.id;
    //Для индивидуалов и анонимных узлов id может отсутствовать
    if (typeof id === 'undefined') return;
    //console.log("owlHelper.js function vowlDatatypePropertyRangeDomain (item)", item, nodes[id].type);
    if ((nodes[id].type != "owl:datatypeProperty")&&(nodes[id].type != "owl:annotationProperty")) return;
    let domain = null, range = null;
    const oDomain = firstAttributes(item.attrs, "http://www.w3.org/2000/01/rdf-schema#domain");
    const domainObject = (oDomain) ? oDomain.value : "http://www.w3.org/2002/07/owl#Thing";
    range = vowlFillLiteral();
    //Возможно, что domainObject является Think, т.е. не привязан ни к одному из классов
    if ((domainObject == null) || (domainObject == "http://www.w3.org/2002/07/owl#Thing")){
      if (!singleThing)
        singleThing = vowlFillThing (true, true);
      else {
        if (nodeAttributes[singleThing].count>maxThingCountLink)
          singleThing = vowlFillThing (true, true);
      }
      nodeAttributes[singleThing].count = nodeAttributes[singleThing].count+1;
      domain = singleThing;
    } else {
      //Отбирается класс, которые в domain или range и для него создаётся Thing
      domain = nodeIds[domainObject];
    }
    if ((domain==null) || (range == null) || (typeof domain === 'undefined')||(typeof range === 'undefined')){
      console.warn("Link parse. No range or domain for DatatypeProperty ", item);
    } else {
      item.domain = domain.toString();
      item.range = range.toString();
    }
    //console.log("owlHelper.js function vowlDatatypePropertyRangeDomain (item)", item);
    vowlIncludeInAttributes(id, "datatype");
  }

  /** Обрабатывает наличие set операторов owl:unionOf, owl:intersectionOf и owl:complementOf  */
  function vowlSetOperators(item){
    //console.log("function vowlSetOperators(item)", item);
    const id = item.id;
    let ofObject = null;
    for (let i = 0; i < item.attrs.length; i++) {
      const a = item.attrs[i];
      if (isURI(a.p, "http://www.w3.org/2002/07/owl#unionOf")){ 
        //console.log("function vowlSetOperators(item)", item);
        nodes[id].type = "owl:unionOf"; 
        ofObject = a.o; 
        item.label ={};
        item.attributes = ["union","anonymous"];
      }
      if (isURI(a.p, "http://www.w3.org/2002/07/owl#intersectionOf")){ 
        nodes[id].type = "owl:intersectionOf"; 
        ofObject = a.o;
        item.label ={};
        item.attributes = ["intersection","anonymous"];
      }
      if (isURI(a.p, "http://www.w3.org/2002/07/owl#complementOf")){ 
        nodes[id].type = "owl:complementOf"; 
        ofObject = a.o;
        item.label ={};
        item.attributes = ["complement","anonymous"];
        return;
      }
    }
    //Есть дополнительные связи
    if (ofObject)
      vowlSetOperatorProperty(item, ofObject);
  }
  
  function vowlSetOperatorProperty(item, node, depth=0){
    //console.log("function vowlSetOperatorProperty(item, node, depth=0)", JSON.stringify(item), JSON.stringify(node), depth);
    if (node && ((node.type=="uri") || (node.type=="bnode"))){
      let idObject = nodeIds[node.value], values=null;
      if (typeof idObject !== 'undefined'){
        values = nodeAttributes[index]
      } else {
        values = unknown[node.value];
        if (typeof values === 'undefined'){
          values = bnodes[node.value];
          if (typeof values === 'undefined'){
            console.warn("Not node for set Operator", item, node, depth);
            return;
          }
        }
      }
      //Создаю связь между узлом item и элементов в http://www.w3.org/1999/02/22-rdf-syntax-ns#first
      const first = firstAttributes(values.attrs, "http://www.w3.org/1999/02/22-rdf-syntax-ns#first");
      if (first==null){
        console.warn("Not first node for set Operator", item, node, depth, idObject);
        return;
      }
      vowlFillSetOperatorProperty(item.id, nodeIds[first.value], node.value);
      const rest = firstAttributes(values.attrs, "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest");
      if (rest==null){
        console.warn("Not rest node for set Operator", item, node, depth, idObject);
        return;
      }
      if (isURI(rest, "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil")) return;
      vowlSetOperatorProperty(item, rest, depth+1);
    }
  }

  function vowlAfterOWL2VOWL(){
    const noSingels = things.filter(t=> !t.single);
    if (noSingels.length>0){
      let thingDomain = (singleThing)?singleThing:noSingels[0].id;
      for (let i = 0; i < things.length; i++) {
        const thing = things[i];
        if (thing.single) continue;
        if (singleThing){
          const index = nodes.length;
          nodes.push({"id": index, "type": "CloneNode"});
          nodeAttributes.push({range: thing.id.toString(), id: index, domain: singleThing.toString(), "attributes" : [ "anonymous" ]});    
        }
      }  
    }
    //Установим праметры языка, первым устанавливается язык с наибольшим количеством использованием
    //console.log("owlHelper.js function vowlAfterOWL2VOWL()", statistics);

    const langs = statistics.lang.sort((a, b) => a.count - b.count)
    header.languages = [];
    // const languages = langs.map(item => item);
    // header.languages = languages;
    const keys = Object.keys(langs);
    for (let i = 0; i < keys.length; i++) {
      const lang = langs[keys[i]]; 
      header.languages[i] = lang.name;
    }
    if (header.languages.length<1) header.languages = ["undefined"];
    if (!(header.languages.some(lang => lang=="undefined")))
      header.languages[header.languages.length] = "undefined";
    //Установим максимальный вес языка для указанного в настройках
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.defaultLanguage){
      const lang = conversionSettings.settings.extra_options.defaultLanguage;
      header.languages = header.languages.filter(item => item !== lang);
      header.languages = [lang, ... header.languages];
      header.defaultLanguage = lang;
    }
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.legend){
      header.legend = conversionSettings.settings.extra_options.legend;
    }    
  }

  /** Проверяет, что тип субъекта (т.е. значение o.value) используется для создания узла. True - создавать */
  function checkIsNodeCreate(s, o){
    if (types.includes(o.value)) return true;
    if (conversionSettings && conversionSettings.settings && Array.isArray(conversionSettings.settings.createNodes)){
      if (conversionSettings.settings.createNodes.includes(o.value))
        return true;
    }
    if (conversionSettings && Array.isArray(conversionSettings.logger)){
      if (conversionSettings.logger.includes("NotSupportedType_AS_ERROR"))
      console.error("Not supported owl2vowl type ", o, s, conversionSettings)
    else
      if (conversionSettings.logger.includes("NotSupportedType_AS_WARN"))
        console.warn("Not supported owl2vowl type ", o, s, conversionSettings)
      else 
        if (conversionSettings.logger.includes("NotSupportedType_AS_LOG"))
          console.log("Not supported owl2vowl type ", o, s, conversionSettings)
    } else {
      console.warn("Not supported owl2vowl type ", o, s, conversionSettings);
    }
    return false;
  }

  /** Проверяет, что используется для создания узла. True - создавать */
  function checkIsTypeCreate(o, s){ 
    if (objectNoCreated.includes(o.value)){
      if (conversionSettings && conversionSettings.settings && Array.isArray(conversionSettings.settings.createTypes)){
        if (conversionSettings.settings.createTypes.includes(o.value))
         return true;
      }
      if (conversionSettings && Array.isArray(conversionSettings.logger)){
        if (conversionSettings.logger.includes("SkipCreateType_AS_ERROR"))
          console.error("Skip create owl2vowl type ", o, s, conversionSettings)
        else
          if (conversionSettings.logger.includes("SkipCreateType_AS_WARN"))
            console.warn("Skip create owl2vowl type ", o, s, conversionSettings)
          else 
            if (conversionSettings.logger.includes("SkipCreateType_AS_LOG"))
              console.log("Skip create owl2vowl type ", o, s, conversionSettings)
      }else {
        console.warn("Skip create owl2vowl type ", o, s, conversionSettings);
      }      
      return false;
    }
    return true;
  }

  /** Проверяет, что тип, определяет наследование субъекта. Т.е. объект и субъект имеют отношение генерализации */
  function checkTypeAsSuperClass(s, o){
    return (conversionSettings && conversionSettings.settings && conversionSettings.settings.typeAsSuperClass)? true: false;
  }

  return helper;

};